import React from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import Greeting from "../greeting/Greeting";
import Skills from "../skills/Skills";
import Timeline from "../../components/timeline/Timeline";
import Certifications from "../certifications/Certifications";
import Projects from "../../pages/projects/Projects";
import Testimonials from "../../components/testimonials/Testimonials";
import Education from "../../components/education/Education";
import ProductPortfolio from "../productPortfolio/ProductPortfolio";
import { experience } from "../../portfolio";
import "./SinglePage.css";

const SinglePage = ({ theme }) => {
  // Flatten all experiences into a single array, excluding achievements
  const allExperiences = [];
  experience.sections.forEach((section) => {
    // Skip achievements section (hackathons)
    if (section.title.toLowerCase() !== "achievements") {
      section.experiences.forEach((exp) => {
        allExperiences.push({
          ...exp,
          section: section.title,
        });
      });
    }
  });

  // Sort experiences by date (most recent first)
  const sortedExperiences = allExperiences.sort((a, b) => {
    // Simple date sorting - you might want to improve this
    return (
      new Date(b.duration.split(" - ")[0]) -
      new Date(a.duration.split(" - ")[0])
    );
  });

  return (
    <div className="single-page">
      <Header theme={theme} />

      {/* Hero Section */}
      <section id="home" className="page-section">
        <Greeting theme={theme} />
      </section>

      {/* Skills Section */}
      <section id="skills" className="page-section">
        <div className="section-header">
          <h2
            className="section-title holographic"
            style={{ color: theme.text }}
          >
            Skills
          </h2>
          <div
            className="section-divider"
            style={{ backgroundColor: theme.imageHighlight }}
          ></div>
        </div>
        <Skills theme={theme} />
      </section>

      {/* Projects Section */}
      <section id="projects" className="page-section">
        <div className="section-header">
          <h2
            className="section-title holographic"
            style={{ color: theme.text }}
          >
            Products Built
          </h2>
          <div
            className="section-divider"
            style={{ backgroundColor: theme.imageHighlight }}
          ></div>
        </div>
        <Projects theme={theme} />
      </section>

      {/* Product Portfolio Section */}
      <section id="product-portfolio" className="page-section">
        <div className="section-header">
          <h2
            className="section-title holographic"
            style={{ color: theme.text }}
          >
            Product Cases
          </h2>
          <div
            className="section-divider"
            style={{ backgroundColor: theme.imageHighlight }}
          ></div>
        </div>
        <ProductPortfolio theme={theme} />
      </section>

      {/* Education Section */}
      {/* <section id="education" className="page-section">
        <Education theme={theme} />
      </section> */}

      {/* Experience Timeline Section */}
      <section id="experience" className="page-section">
        <div className="section-header">
          <h2
            className="section-title holographic"
            style={{ color: theme.text }}
          >
            Work
          </h2>
          <div
            className="section-divider"
            style={{ backgroundColor: theme.imageHighlight }}
          ></div>
        </div>
        <Timeline experiences={sortedExperiences} theme={theme} />
      </section>

      {/* Awards Section */}
      <section id="awards" className="page-section">
        <div className="section-header">
          <h2
            className="section-title holographic"
            style={{ color: theme.text }}
          >
            Awards
          </h2>
          <div
            className="section-divider"
            style={{ backgroundColor: theme.imageHighlight }}
          ></div>
        </div>
        <Certifications theme={theme} />
      </section>

      {/* Testimonials Section */}
      <section id="testimonials" className="page-section">
        <Testimonials theme={theme} />
      </section>

      <Footer theme={theme} />
      <TopButton theme={theme} />
    </div>
  );
};

export default SinglePage;
